// src/components/NavButton.tsx
import React, { useState } from "react";
import { theme } from "@/styles/theme";

export type NavButtonProps = {
  label: string;
  onClick?: () => void;
  small?: boolean;
  selected?: boolean;
  /** Optional ref so parent can compute anchorRect for window animation */
  buttonRef?: (el: HTMLButtonElement | null) => void;
};

export function NavButton({
  label,
  onClick,
  small,
  selected,
  buttonRef,
}: NavButtonProps) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  const padding = small ? "4px 10px" : "8px 20px";
  const fontSize = small ? 24 : 24;

  let textColor = theme.colors.Green;

  if (selected) {
    textColor = theme.colors.Green;
  } else if (pressed) {
    textColor = theme.colors.LightGreen;
  } else if (hovered) {
    textColor = theme.colors.White;
  }

  let underlineWidth = "0%";
  if (selected) {
    underlineWidth = "80%";
  } else if (hovered && !pressed) {
    underlineWidth = "80%";
  }

  return (
    <button
      ref={buttonRef || undefined}
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      style={{
        position: "relative",
        background: "transparent",
        border: "none",
        color: textColor,
        padding,
        cursor: "pointer",
        textTransform: "uppercase",
        fontSize,
        fontFamily: theme.fonts.body,
        outline: "none",
        overflow: "hidden",
      }}
    >
      <span
        style={{
          position: "relative",
          zIndex: 1,
        }}
      >
        {label}
      </span>
      <span
        style={{
          position: "absolute",
          left: "50%",
          bottom: 0,
          width: underlineWidth,
          height: 2,
          background: textColor,
          transform: "translateX(-50%)",
          transition: "width 0.2s ease",
        }}
      />
    </button>
  );
}
